export function newsletter() {
  const newsletterWrapper = document.querySelector(".newsletter-subscribe");
  const newsletterClose = document.querySelector(
    ".newsletter-subscribe--close"
  );

  if (!newsletterWrapper || !newsletterClose) {
    return;
  }

  const scrollThreshold = 2000;
  const localStorageKey = "newsletterClosed";

  function toggleClassOnScroll() {
    if (window.scrollY >= scrollThreshold) {
      newsletterWrapper.classList.add("show");
    }
  }

  window.addEventListener("scroll", toggleClassOnScroll);

  toggleClassOnScroll();

  function removeClassOnClick() {
    if (newsletterWrapper.classList.contains("show")) {
      newsletterWrapper.classList.remove("show");

      localStorage.setItem(localStorageKey, "true");

      window.removeEventListener("scroll", toggleClassOnScroll);
    }
  }

  newsletterClose.addEventListener("click", removeClassOnClick);

  const isNewsletterClosed = localStorage.getItem(localStorageKey) === "true";
  if (isNewsletterClosed) {
    newsletterWrapper.style.display = "none";
  }
}
